// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991.98px) and (min-width: 576px) {
  .card-profile-stats {
    margin-top: 60px !important;
  }
}
.card.card-profile {
  z-index: 5;
}

.section-profile-cover {
  height: 470px;
}

.headings {
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 1rem 0;
  margin-bottom: 1rem;
  font-weight: 600;
  background-color: #a998d7;
  color: #000;
}

td.info-cell {
  display: flex;
  justify-content: center;
}

.check-icon {
  color: green;
}

.error-icon {
  color: #f44336;
}

.map-card {
  border-bottom: solid 2px #3f51b5;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.checkbox-text-error {
  color: #f44336;
}

.radio-text-error {
  color: #f44336;
}

mat-radio-button {
  padding-right: 16px;
}

.constraints_border {
  border-bottom: 2px #eee solid;
  margin-bottom: 0.5rem;
}

.check-address-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.34375em;
}`, "",{"version":3,"sources":["webpack://./src/app/nonAdmin/profile/edit/edit.component.scss"],"names":[],"mappings":"AAAA;EACI;IACI,2BAAA;EACN;AACF;AAEA;EACI,UAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AASA;EAEI,mBAAA;EACA,kBAAA;EAGA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AATJ;;AAcA;EACI,aAAA;EACA,uBAAA;AAXJ;;AAcA;EACI,YAAA;AAXJ;;AAcA;EACI,cAAA;AAXJ;;AAcA;EACI,gCAAA;EACA,8BAAA;EACA,+BAAA;AAXJ;;AAcA;EACI,cAAA;AAXJ;;AAcA;EACI,cAAA;AAXJ;;AAcA;EACI,mBAAA;AAXJ;;AAcA;EACI,6BAAA;EACA,qBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAXJ","sourcesContent":["@media (max-width: 991.98px) and (min-width: 576px)  {\r\n    .card-profile-stats {\r\n        margin-top: 60px !important;\r\n    }\r\n}\r\n\r\n.card.card-profile {\r\n    z-index: 5;\r\n}\r\n\r\n.section-profile-cover {\r\n    height: 470px;\r\n}\r\n\r\n// @media (max-width: 991.98px) {\r\n//     .section-profile-cover {\r\n//         height: 300px;\r\n//     }\r\n// }\r\n\r\n.headings {\r\n    // background-color: #fff3cd;\r\n    letter-spacing: 1px;\r\n    border-radius: 5px;\r\n    // background-color: #593faa;\r\n    // color: #fff;\r\n    padding: 1rem 0;\r\n    margin-bottom: 1rem;\r\n    font-weight: 600;\r\n    background-color: #a998d7;\r\n    color: #000;\r\n\r\n}\r\n\r\n\r\ntd.info-cell {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.check-icon {\r\n    color: green\r\n}\r\n\r\n.error-icon {\r\n    color: #f44336;\r\n}\r\n\r\n.map-card{\r\n    border-bottom: solid 2px #3f51b5;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px\r\n}\r\n\r\n.checkbox-text-error {\r\n    color: #f44336;\r\n}\r\n\r\n.radio-text-error {\r\n    color: #f44336;\r\n}\r\n\r\nmat-radio-button {\r\n    padding-right: 16px;\r\n}\r\n\r\n.constraints_border {\r\n    border-bottom: 2px #eee solid;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.check-address-btn-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding-bottom: 1.34375em;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
